import styled from 'styled-components';
import DrawerCommonPanel from '../../../drawer-contents/DrawerCommonPanel';

const white = '#fff';
const graydiant03 = '#ddd';
const graydiant05 = '#ccc';
const graydiant06 = '#999';
const graydiant07 = '#666';
const graydiant08 = '#333';
const blue = '#45bce5';
const pinkishGrey = '#cccccc';

export const TextBold = styled.div`
  font-family: LatoSemibold, DefaultLatoBold, 'sans-serif';
  font-size: 18px;
  text-align: left;
  color: ${graydiant08};
  margin: 16px 0 32px 0;
`;

export const DrawerCommonPanelCustom = styled(DrawerCommonPanel)`
  margin: 40px 36px 0 36px !important;
  min-height: calc(100% - 120px) !important;
`;

export const User = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
  cursor: pointer;
  opacity: ${props => (props.isEnabled === 1 ? 1 : 0.2)};

  .selected {
    color: ${props => (props.primaryColor ? props.primaryColor : '#45bce5')};
    border-color: ${props => (props.primaryColor ? props.primaryColor : '#45bce5')};
  }
`;

export const Avatar = styled.img`
  border-radius: 50%;
  border: ${props => (props.isMenuB ? `solid 2px ${blue}` : `solid 2px ${graydiant05}`)};
  box-sizing: border-box;
  width: 40px;
  height: 40px;
`;

export const Name = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: LatoSemibold, DefaultLatoBold, 'sans-serif';
  font-size: 16px;
  color: ${graydiant07};
  padding-left: 20px;
`;

export const Mail = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: LatoSemibold, DefaultLatoBold, 'sans-serif';
  font-size: 16px;
  font-style: italic;
  color: ${graydiant06};
  padding-left: 8px;
`;

export const CustomSelectButton = styled.div`
  height: 50px;
  border: solid 1px ${pinkishGrey};
  background-color: ${white};
  border-radius: 3px;
  color: #333333;

  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
